export default {
  SET_TEACHERS(state, users) {
    state.teachers = users
  },
  SET_INTERNAL_EXTERNAL_TEACHERS(state, users) {
    let internalTeachers = users.filter(function (el) {
      return el.teacher_type == "internal";
    });

    let externalTeachers = users.filter(function (el) {
      return el.teacher_type == "external";
    });

    state.internalTeachers = internalTeachers
    state.externalTeachers = externalTeachers
  },
  SET_TEACHERS_COUNT(state, count) {
    state.teachersCount = count
  },
  SET_STUDENTS(state, users) {
    state.students = users
  },
  SET_STUDENTS_REGISTATION_X(state, data) {
    state.studentsRegistationX = data
  },
  SET_STUDENTS_REGISTATION_Y(state, data) {
    state.studentsRegistationY = data
  },
  SET_STUDENTS_COUNT(state, count) {
    state.studentsCount = count
  },
  SET_UNREAD_NOTIFICATIONS(state, count) {
    state.unreadNotificationsCount = count; 
  },
  SET_UNREAD_CHATS(state, count) {
    state.unreadChatsCount = count; 
  },
  SET_NOTIFICATIONS(state, payload) {
    state.notifications = (payload.current_page == 1) ? payload.data : state.notifications.concat(payload.data); 
    state.notificationsLastPage = payload.last_page
    state.notificationsCurrentPage = payload.current_page
  },
  REMOVE_STUDENT(state, userId) {
      const ItemIndex = state.students.findIndex((p) => p.id == userId)
      state.students.splice(ItemIndex, 1)
      state.studentsCount = state.students.count
  },
  REMOVE_TEACHER(state, userId) {
      const ItemIndex = state.teachers.findIndex((p) => p.id == userId)
      state.teachers.splice(ItemIndex, 1)
      state.teachersCount = state.teachers.count
  },
}
